import React, { ReactElement } from 'react';
import { useParams } from 'react-router-dom';

import Loader from '../components/Loader';
import { useGetScan } from '../services/hooks/useGetScan';
import { User } from '../types/User';
import ScanOrBoxDetail from './ScanOrBoxDetail/ScanOrBoxDetail';
import BoxScanOverview from './BoxScanOverview';
import ErrorPage from './ErrorPage';

export interface ScanProps {
    currentUser: User;
}

const ScansHandler = ({ currentUser }: ScanProps): ReactElement => {
    const { scanId } = useParams();
    const { data: scanRes, isLoading: isLoadingScan, error: scanError } = useGetScan({ scanId: scanId });

    if (isLoadingScan) {
        return <Loader size={20} loading={isLoadingScan} overComponent={true} />;
    }

    if (scanError) {
        return <ErrorPage statusCode={scanError.status} />;
    }

    return (
        <>
            {scanRes?.isBoxScan ? (
                <BoxScanOverview currentUser={currentUser} />
            ) : (
                <ScanOrBoxDetail currentUser={currentUser} />
            )}
        </>
    );
};

export default ScansHandler;
